module.exports = __webpack_public_path__ + "img/turbo2.c32f03a4.jpg";